import { Gamepad2, Wind, Headphones, Gift, Sparkles, Shirt, BookOpen, ShoppingBag, KeyRound, Sticker, Package, Disc, Camera, Video, Battery, Film, Image, Frame, ToyBrick, Boxes, Waves, Aperture, Backpack, Plane, Mic, Cable, Zap, Layers, Footprints, Gem, CupSoda, SprayCan, Coffee, Laptop, Glasses, Watch, Wrench, Wallet, Ruler, Notebook, CreditCard, Briefcase, Car, Tablet, Tag, Utensils } from "lucide-react";

// Tier colors are used purely for visual styling. Each item defines its OWN
// exact drop percentage; the tier is auto-derived from that percentage so
// rarer items glow with hotter colors.
export const TIER_META = {
  common:    { label: "Common",    color: "#9CA3AF", order: 0 },
  uncommon:  { label: "Uncommon",  color: "#22C55E", order: 1 },
  rare:      { label: "Rare",      color: "#3B82F6", order: 2 },
  epic:      { label: "Epic",      color: "#8B5CF6", order: 3 },
  legendary: { label: "Legendary", color: "#F59E0B", order: 4 },
  mythic:    { label: "Mythic",    color: "#EC4899", order: 5 },
};
export const TIER_ORDER = ["mythic", "legendary", "epic", "rare", "uncommon", "common"];

function tierForRate(p) {
  if (p <= 0.05) return "mythic";
  if (p <= 0.5) return "legendary";
  if (p <= 3) return "epic";
  if (p <= 10) return "rare";
  if (p <= 25) return "uncommon";
  return "common";
}

// it(name, value, rate%, icon) — tier is derived from the exact drop rate.
const it = (name, value, rate, icon) => ({ name, value, rate, icon, tier: tierForRate(rate) });

export const CASES = [
  {
    id: "sheepskin", name: "Sheepskin", price: 32.0, accent: "#B07A4F",
    badge: "NEW", opens: 6120, added: 3, volatility: "High",
    tagline: "UGG comfort drop · high volatility",
    items: [
      it("UGG Ultra Mini Platform Boots", 170, 0.4, Footprints),
      it("UGG Classic Mini Boots", 150, 0.9, Footprints),
      it("UGG Sherpa Mini Tote", 120, 1.6, ShoppingBag),
      it("UGG Tasman Slippers", 110, 2.6, Footprints),
      it("UGG Fluff Yeah Slides", 100, 3.6, Footprints),
      it("UGG Scuffette Slippers", 90, 5.0, Footprints),
      it("UGG Classic Beanie", 45, 12.0, Shirt),
      it("UGG Cozy Socks", 20, 24.0, Shirt),
      it("UGG Sticker", 8, 49.9, Sticker),
    ],
  },
  {
    id: "flight-club", name: "Flight Club", price: 45.0, accent: "#CE1141",
    badge: "HOT", opens: 8940, added: 3, volatility: "Extreme",
    tagline: "Air Jordan grails · extreme volatility",
    items: [
      it("Air Jordan 4 Retro Fire Red", 400, 0.3, Footprints),
      it("Air Jordan 1 High Bred", 350, 0.5, Footprints),
      it("Air Jordan 11 Concord", 300, 0.9, Footprints),
      it("Air Jordan 3 White Cement", 220, 1.8, Footprints),
      it("Jordan Duffle Bag", 95, 4.0, Briefcase),
      it("Jordan Flight Hoodie", 85, 6.5, Shirt),
      it("Jordan Backpack", 70, 10.0, Backpack),
      it("Jordan Logo Tee", 40, 21.0, Shirt),
      it("Jordan Sticker", 18, 55.0, Sticker),
    ],
  },
  {
    id: "bullseye", name: "Bullseye", price: 9.19, accent: "#CC0000",
    badge: "HOT", opens: 18234, added: 2, volatility: "High",
    tagline: "Target finds · high volatility",
    items: [
      it("Nintendo Switch 2", 450, 0.0166, Gamepad2),
      it("Dyson Supersonic", 449.99, 0.0166, Wind),
      it("AirPods 4", 129, 0.3336, Headphones),
      it("$100 Target Gift Card", 100, 0.3336, Gift),
      it("$50 Target Gift Card", 50, 2.0521, Gift),
      it("$25 Target Gift Card", 25, 5.9855, Gift),
      it("$10 Target Gift Card", 10, 15.1768, Gift),
      it("$5 Target Gift Card", 5, 15.1768, Gift),
      it("Bullseye Playground Item", 3, 60.9084, Sparkles),
    ],
  },
  {
    id: "companion", name: "Companion", price: 9.45, accent: "#EAB308",
    badge: "LIMITED", opens: 9210, added: 1, volatility: "Extreme",
    tagline: "KAWS drop · extreme volatility",
    items: [
      it("Rare KAWS Figure", 3500, 0.0055, ToyBrick),
      it("KAWS COMPANION Figure", 525, 0.0242, ToyBrick),
      it("KAWS CHUM Figure", 250, 0.0276, Boxes),
      it("KAWS Collectible", 180, 0.0276, ToyBrick),
      it("KAWS Tee", 80, 0.4644, Shirt),
      it("KAWS Art Book", 45, 0.9893, BookOpen),
      it("KAWS Tote", 30, 1.4695, ShoppingBag),
      it("KAWS Keychain", 15, 6.3977, KeyRound),
      it("KAWS Sticker/Postcard Pack", 5, 90.5942, Sticker),
    ],
  },
  {
    id: "one-up", name: "1-Up", price: 9.9, accent: "#E60012",
    badge: "NEW", opens: 24102, added: 3, volatility: "High",
    tagline: "Nintendo play box · high volatility",
    items: [
      it("Nintendo Switch 2", 450, 0.0164, Gamepad2),
      it("Switch 2 + Game Bundle", 520, 0.0164, Package),
      it("Switch 2 Pro Controller", 85, 0.9986, Gamepad2),
      it("First-Party Switch 2 Game", 80, 0.9986, Disc),
      it("$50 Nintendo eShop Card", 50, 1.5128, Gift),
      it("$25 eShop Card", 25, 5.9369, Gift),
      it("$10 eShop Card", 10, 15.0534, Gift),
      it("$5 eShop Card", 5, 15.0534, Gift),
      it("Nintendo Small Collectible", 3, 60.4135, Sparkles),
    ],
  },
  {
    id: "snapshot", name: "Snapshot", price: 10.19, accent: "#1D9BF0",
    badge: "NEW", opens: 12045, added: 2, volatility: "High",
    tagline: "Polaroid snap box · high volatility",
    items: [
      it("Polaroid I-2", 600, 0.0171, Camera),
      it("Premium Instant Camera Bundle", 250, 0.0747, Package),
      it("Polaroid Now+", 150, 0.1524, Camera),
      it("Polaroid Go", 80, 0.9965, Camera),
      it("Double Film Pack", 34, 3.9657, Film),
      it("Color Film", 20, 8.4856, Film),
      it("Photo Album", 15, 8.4856, Image),
      it("Photo Frame", 7, 9.7157, Frame),
      it("Old Photos", 3, 68.1067, Sparkles),
    ],
  },
  {
    id: "basecamp", name: "Basecamp", price: 7.93, accent: "#F26722",
    badge: "HOT", opens: 8730, added: 1, volatility: "High",
    tagline: "The North Face trail box · high volatility",
    items: [
      it("Summit Series Shell", 650, 0.0172, Shirt),
      it("1996 Retro Nuptse", 330, 0.0416, Shirt),
      it("Denali Fleece", 180, 0.1175, Shirt),
      it("Borealis Backpack", 100, 0.5238, Backpack),
      it("TNF Hoodie", 70, 0.9436, Shirt),
      it("TNF Tee", 35, 3.3465, Shirt),
      it("TNF Beanie", 30, 3.3465, Shirt),
      it("TNF Socks", 18, 10.3696, Footprints),
      it("TNF Sticker", 1, 81.2937, Sticker),
    ],
  },
  {
    id: "airborne", name: "Airborne", price: 6.66, accent: "#4B5563",
    badge: "LIMITED", opens: 20488, added: 3, volatility: "Extreme",
    tagline: "DJI fly box · extreme volatility",
    items: [
      it("DJI Avata/Premium Drone Bundle", 1019, 0.0055, Plane),
      it("DJI Mini Fly More Bundle", 909, 0.0055, Plane),
      it("Osmo Pocket Creator Bundle", 669, 0.0055, Camera),
      it("Osmo Pocket 3", 519, 0.0055, Camera),
      it("DJI Mic Mini", 89, 0.3847, Mic),
      it("Battery/Charging Hub", 45, 1.1309, Battery),
      it("Propeller/Accessory Kit", 20, 4.7957, Package),
      it("Cable/Adapter", 12, 4.8921, Cable),
      it("Small DJI Accessory", 6, 7.8019, Sparkles),
      it("DJI Sticker/Tiny Accessory", 2.5, 80.9727, Sticker),
    ],
  },
  {
    id: "cyclone", name: "Cyclone", price: 7.01, accent: "#D6336C",
    badge: "HOT", opens: 14260, added: 2, volatility: "Extreme",
    tagline: "Dyson home tech · extreme volatility",
    items: [
      it("Premium Dyson Cordless Vacuum", 799.99, 0.0055, Wind),
      it("Dyson Airwrap", 599.99, 0.0055, Wind),
      it("Dyson Airstrait", 499.99, 0.0055, Wind),
      it("Dyson Supersonic", 449.99, 0.0055, Wind),
      it("Premium Styling Attachment", 60, 0.9311, Sparkles),
      it("Replacement Filter", 40, 0.9311, Package),
      it("Storage Case", 30, 1.1375, Package),
      it("Comb/Brush Accessory", 20, 3.3257, Sparkles),
      it("Small Attachment", 8, 9.0232, Sparkles),
      it("Dyson Sticker", 3, 84.6294, Sticker),
    ],
  },
  {
    id: "black-bolt", name: "Black Bolt", price: 9.22, accent: "#EAB308",
    badge: "NEW", opens: 31905, added: 3, volatility: "High",
    tagline: "Pokémon TCG mystery case · high volatility",
    items: [
      it("Black Bolt Zekrom PSA 9.5", 750, 0.0174, Zap),
      it("Premium Black Bolt Collection", 90, 0.6957, Package),
      it("Pokémon Center Black Bolt ETB", 260, 0.0828, Package),
      it("Black Bolt ETB", 155, 0.135, Package),
      it("Black Bolt Booster Bundle", 90, 0.6957, Layers),
      it("Black Bolt 3-Pack Blister", 35, 4.1238, Layers),
      it("Black Bolt Booster Pack", 16, 14.4431, Layers),
      it("Black Bolt Holo/Reverse-Holo", 2.5, 79.8065, Sparkles),
    ],
  },
  {
    id: "sport-mode", name: "Sport Mode", price: 14.32, accent: "#84CC16",
    badge: "NEW", opens: 17540, added: 1, volatility: "Medium-High",
    tagline: "Crocs comfort box · medium-high volatility",
    items: [
      it("Pollex clog", 400, 0.0961, Footprints),
      it("Premium Collab Pair", 120, 1.0308, Footprints),
      it("Echo Clog", 70, 2.0849, Footprints),
      it("Classic Clog", 50, 2.2259, Footprints),
      it("Hello Kitty 5 Pack Jibbitz", 30, 6.5711, Gem),
      it("Jibbitz 5-Pack", 20, 13.1019, Gem),
      it("Jibbitz 3-Pack", 12, 13.1019, Gem),
      it("Premium Single Jibbitz", 6, 13.1019, Gem),
      it("Small Crocs Charm", 3, 48.6855, Gem),
    ],
  },
  {
    id: "bulk-buy", name: "Bulk Buy", price: 8.09, accent: "#005DAA",
    badge: "NEW", opens: 27310, added: 3, volatility: "High",
    tagline: "Costco haul · high volatility",
    items: [
      it("Nintendo Switch 2", 450, 0.0166, Gamepad2),
      it("AirPods 4", 129, 0.3336, Headphones),
      it("$100 Costco Shop Card", 100, 0.3336, Gift),
      it("$50 Shop Card", 50, 2.0525, Gift),
      it("$25 Shop Card", 25, 5.9865, Gift),
      it("$10 Shop Card", 10, 15.1793, Gift),
      it("$5 Shop Card", 5, 15.1793, Gift),
      it("Costco Pizza Slice", 1.99, 16.6575, Package),
      it("Costco Hot Dog", 1.5, 44.2611, CupSoda),
    ],
  },
  {
    id: "quenched", name: "Quenched", price: 12.55, accent: "#3D6B47",
    badge: "HOT", opens: 16820, added: 2, volatility: "Medium-High",
    tagline: "Stanley hydration gear · medium-high volatility",
    items: [
      it("Rare Stanley Collaboration", 180, 0.0849, CupSoda),
      it("Stanley Cooler", 120, 0.911, Package),
      it("Limited Quencher", 70, 1.8425, CupSoda),
      it("Quencher 40oz", 45, 2.8248, CupSoda),
      it("Quencher 30oz", 35, 2.8248, CupSoda),
      it("IceFlow Bottle", 30, 2.8248, CupSoda),
      it("Straw Topper Set", 12, 22.831, Sparkles),
      it("Topper", 6, 22.831, Gem),
      it("Stanley Sticker", 3, 43.0252, Sticker),
    ],
  },
  {
    id: "glow-up", name: "Glow Up", price: 6.35, accent: "#C2185B",
    badge: "LIMITED", opens: 22140, added: 1, volatility: "Extreme",
    tagline: "Sephora beauty picks · extreme volatility",
    items: [
      it("Dyson Airwrap", 599.99, 0.0055, Wind),
      it("Baccarat Rouge 540", 325, 0.0134, SprayCan),
      it("$150 Sephora Gift Card", 150, 0.0705, Gift),
      it("Crystal Contour Collection", 100, 0.1951, Sparkles),
      it("YSL Make Me Blush", 50, 0.9893, Sparkles),
      it("Rhode Pocket Bronze Long", 28, 2.1092, Sparkles),
      it("Colorful 8HR Longwear Transferproof Lip Liner", 10, 9.4551, Sparkles),
      it("Nourishing Foot Mask in Coconut", 5, 9.4551, Sparkles),
      it("Sandalwood Mini Perfume Sample 0.05 oz", 2.5, 77.7068, Sparkles),
    ],
  },
  {
    id: "coffee-run", name: "Coffee Run", price: 11.64, accent: "#00704A",
    badge: "NEW", opens: 29650, added: 3, volatility: "Medium-High",
    tagline: "Starbucks coffee case · medium-high volatility",
    items: [
      it("Rare Starbucks x Stanley", 150, 0.075, CupSoda),
      it("$100 Starbucks Card", 100, 0.4749, Gift),
      it("Limited Starbucks Tumbler", 60, 2.6422, CupSoda),
      it("$25 Starbucks Card", 25, 9.8873, Gift),
      it("$15 Starbucks Card", 15, 14.3138, Gift),
      it("$10 Starbucks Card", 10, 14.3138, Gift),
      it("$5 Starbucks Card", 5, 14.3138, Gift),
      it("Reusable Cup", 3, 14.3138, CupSoda),
      it("Starbucks Cake Pop", 2.95, 29.6654, Coffee),
    ],
  },
  {
    id: "blue-tag", name: "Blue Tag", price: 6.45, accent: "#0046BE",
    badge: "HOT", opens: 34120, added: 2, volatility: "Extreme",
    tagline: "Best Buy tech picks · extreme volatility",
    items: [
      it("MacBook Air", 999, 0.0055, Laptop),
      it("PlayStation 5 Pro", 900, 0.0055, Gamepad2),
      it("Nintendo Switch 2", 450, 0.0113, Gamepad2),
      it("AirPods 4", 129, 0.1196, Headphones),
      it("SanDisk 256GB Extreme Pro", 45, 1.1347, Gift),
      it("Logitech G432 Wired Headset", 50, 1.1347, Headphones),
      it("Soundcore by Anker", 25, 2.6478, Headphones),
      it("Anker 20W Wall Charger", 10, 8.6567, Gift),
      it("Rayovac 4 Pack Batteries", 5, 8.6788, Gift),
      it("Best Buy Sticker", 2, 77.6054, Sticker),
    ],
  },
  {
    id: "no-shade", name: "No Shade", price: 9.33, accent: "#C9A227",
    badge: "NEW", opens: 19430, added: 3, volatility: "High",
    tagline: "Ray-Ban shades drop · high volatility",
    items: [
      it("Ray-Ban Meta", 379, 0.0138, Glasses),
      it("Original Wayfarer Polarized", 216, 0.0556, Glasses),
      it("Original Wayfarer", 173, 0.0556, Glasses),
      it("Premium Ray-Ban Sunglasses", 180, 0.0556, Glasses),
      it("Ray-Ban Care Kit", 20, 10.9297, Package),
      it("Ray-Ban Lanyard", 19, 10.9297, KeyRound),
      it("Cleaning Cloth", 6, 13.6178, Sparkles),
      it("Case Accessory", 5, 13.6178, Package),
      it("Small Ray-Ban Accessory", 3, 50.7244, Sticker),
    ],
  },
  {
    id: "second-hand", name: "Second Hand", price: 15.65, accent: "#1B3A5B",
    badge: "LIMITED", opens: 7620, added: 1, volatility: "Medium",
    tagline: "Seiko dive box · medium volatility",
    items: [
      it("Seiko Prospex", 950, 0.0987, Watch),
      it("Seiko Presage", 500, 0.1004, Watch),
      it("Seiko 5 Sports", 295, 0.1552, Watch),
      it("Seiko Quartz Watch", 200, 0.187, Watch),
      it("Leather Strap", 60, 3.661, Package),
      it("Bracelet/Strap", 45, 3.661, Package),
      it("Watch Tool Kit", 25, 10.6338, Wrench),
      it("Watch Pouch", 12, 21.669, Package),
      it("Cloth/Spring-Bar Tool", 4, 59.8339, Sparkles),
    ],
  },
  {
    id: "jobsite", name: "Jobsite", price: 14.81, accent: "#FEBD17",
    badge: "HOT", opens: 13280, added: 2, volatility: "Medium-High",
    tagline: "DeWalt tool drop · medium-high volatility",
    items: [
      it("6-Tool Combo Kit", 599, 0.0994, Wrench),
      it("4-Tool Combo Kit", 399, 0.0994, Wrench),
      it("Drill/Impact Kit", 200, 0.3111, Wrench),
      it("Battery 2-Pack", 150, 0.3111, Battery),
      it("20V MAX Battery", 99, 0.9675, Battery),
      it("Bit Set", 35, 8.0772, Package),
      it("Tape Measure", 20, 16.1809, Ruler),
      it("Utility Knife", 10, 16.1809, Wrench),
      it("Small DeWalt Accessory", 4, 57.7725, Sparkles),
    ],
  },
  {
    id: "green-light", name: "Green Light", price: 8.88, accent: "#107C10",
    badge: "NEW", opens: 33470, added: 3, volatility: "High",
    tagline: "Xbox drop · high volatility",
    items: [
      it("Xbox Series X", 799.99, 0.0165, Gamepad2),
      it("Xbox Series S", 499.99, 0.0183, Gamepad2),
      it("Elite Wireless Controller", 180, 0.1415, Gamepad2),
      it("Xbox Wireless Controller", 65, 1.6022, Gamepad2),
      it("$50 Xbox Card", 50, 1.6022, Gift),
      it("$25 Xbox Card", 25, 5.9468, Gift),
      it("$10 Xbox Card", 10, 15.0787, Gift),
      it("$5 Xbox Card", 5, 15.0787, Gift),
      it("$2 Xbox Digital Credit", 2, 60.5151, Gift),
    ],
  },
  {
    id: "monogram", name: "Monogram", price: 6.55, accent: "#7A5230",
    badge: "LIMITED", opens: 25980, added: 1, volatility: "Extreme",
    tagline: "Louis Vuitton luxury picks · extreme volatility",
    items: [
      it("LV Neverfull", 2310, 0.0055, ShoppingBag),
      it("LV Keepall", 2780, 0.0055, Briefcase),
      it("LV Sarah Wallet", 935, 0.0091, Wallet),
      it("LV Card Holder", 490, 0.0134, CreditCard),
      it("LV Key Pouch", 375, 0.0134, KeyRound),
      it("LV City Guide/Book", 45, 0.8803, BookOpen),
      it("LV Notebook", 75, 0.6124, Notebook),
      it("LV Paper Bag", 8, 13.82, Sparkles),
      it("LV Receipt Holder", 3, 84.6404, Sticker),
    ],
  },
  {
    id: "street-archive", name: "Street Archive", price: 8.82, accent: "#DA1F26",
    badge: "HOT", opens: 21360, added: 2, volatility: "High",
    tagline: "Supreme + Stüssy · high volatility",
    items: [
      it("Supreme Shanghai Box Logo Hoodie", 650, 0.0175, Shirt),
      it("Supreme Jacket", 550, 0.0175, Shirt),
      it("Stüssy Premium Jacket", 250, 0.0754, Shirt),
      it("Supreme Hoodie", 180, 0.0806, Shirt),
      it("Stüssy Hoodie", 140, 0.1192, Shirt),
      it("Supreme Tee", 90, 0.6384, Shirt),
      it("Stüssy Tee", 50, 1.9422, Shirt),
      it("Socks", 30, 3.6197, Shirt),
      it("Burberry X Supreme Sticker", 8, 21.793, Sticker),
      it("Supreme Sticker", 3, 71.6965, Sticker),
    ],
  },
  {
    id: "cupertino", name: "Cupertino", price: 5.91, accent: "#1D1D1F",
    badge: "LIMITED", opens: 41280, added: 3, volatility: "Extreme",
    tagline: "Apple mystery case · extreme volatility",
    items: [
      it("MacBook Air", 999, 0.0055, Laptop),
      it("iPad", 349, 0.0205, Tablet),
      it("Apple Watch SE", 249, 0.0205, Watch),
      it("AirPods 4 ANC", 179, 0.0267, Headphones),
      it("AirPods 4", 129, 0.0691, Headphones),
      it("AirTag", 29, 3.0559, Tag),
      it("USB-C Cable", 20, 3.1319, Cable),
      it("$10 Apple Gift Card", 10, 6.6102, Gift),
      it("$5 Apple Gift Card", 5, 8.7568, Gift),
      it("$2 Apple Credit", 2, 78.3029, Gift),
    ],
  },
  {
    id: "m-division", name: "M Division", price: 7.37, accent: "#0066B1",
    badge: "LIMITED", opens: 18990, added: 1, volatility: "Extreme",
    tagline: "BMW M Performance box · extreme volatility",
    items: [
      it("M Performance Exhaust/Major Part", 2500, 0.0055, Car),
      it("Carbon Spoiler", 800, 0.0082, Car),
      it("M Steering Wheel/Trim", 1000, 0.0082, Car),
      it("Genuine BMW Floor Mats", 180, 0.058, Car),
      it("BMW M Thermo Mug Black", 60, 0.8705, CupSoda),
      it("BMW M Cap", 40, 0.9165, Shirt),
      it("BMW Keychain", 30, 1.1377, KeyRound),
      it("BMW Badge", 18, 4.6634, Sparkles),
      it("BMW M Decal", 7, 9.3099, Sticker),
      it("Sticker", 3, 83.0221, Sticker),
    ],
  },
  {
    id: "player-one", name: "Player One", price: 8.65, accent: "#003791",
    badge: "HOT", opens: 37610, added: 2, volatility: "High",
    tagline: "PlayStation mystery case · high volatility",
    items: [
      it("PlayStation 5 Pro", 900, 0.0162, Gamepad2),
      it("PlayStation 5", 650, 0.0162, Gamepad2),
      it("PlayStation Portal", 200, 0.1245, Gamepad2),
      it("DualSense Edge", 200, 0.1245, Gamepad2),
      it("DualSense Controller", 75, 1.2337, Gamepad2),
      it("Hello Kitty Island Adventure", 50, 1.2735, Gift),
      it("PS5 Charging Station", 30, 3.3411, Gamepad2),
      it("PS5 Charger", 10, 17.2717, Gamepad2),
      it("Control Freaks", 5, 17.2717, Gamepad2),
      it("PS5 Sticker", 2, 59.3269, Gift),
    ],
  },
  {
    id: "golden-arches", name: "Golden Arches", price: 10.7, accent: "#DA291C",
    badge: "NEW", opens: 44720, added: 3, volatility: "Medium-High",
    tagline: "McDonald's mystery box · medium-high volatility",
    items: [
      it("$250 Arch Card", 250, 0.0766, Gift),
      it("$100 Arch Card", 100, 1.2177, Gift),
      it("$75 Arch Card", 75, 1.2177, Gift),
      it("$50 Arch Card", 50, 2.0381, Gift),
      it("$25 Arch Card", 25, 9.0266, Gift),
      it("Mac Meal", 10, 18.7047, Utensils),
      it("$5 Meal Deal", 5, 18.7047, Utensils),
      it("Grimace Toy", 3, 18.7047, Utensils),
      it("Potato Head Toy", 1.5, 30.3092, Utensils),
    ],
  },
  {
    id: "crowned", name: "Crowned", price: 9.07, accent: "#006039",
    badge: "LIMITED", opens: 52140, added: 3, volatility: "Ultra Extreme",
    tagline: "Rolex mystery case · ULTRA EXTREME volatility",
    items: [
      it("Rolex Submariner", 10050, 0.0055, Watch),
      it("Rolex GMT-Master II", 11800, 0.0055, Watch),
      it("Rolex Oyster Perpetual", 7050, 0.0055, Watch),
      it("Rolex Box + Papers Set", 400, 0.0405, Package),
      it("Rolex Service Pouch", 120, 0.1222, Package),
      it("Rolex Collector Book", 70, 0.5596, BookOpen),
      it("Rolex Travel/Display Accessory", 40, 1.1321, Sparkles),
      it("Rolex Catalog/Magazine", 20, 4.4639, Notebook),
      it("Rolex Tag/Paper Collectible", 8, 9.0245, Sticker),
      it("Small Rolex Paper Collectible", 3, 84.6407, Sticker),
    ],
  },
];

// Minimum-win floor: the lowest-value pull in every case is set to $0.01,
// EXCEPT gift cards (names starting with "$") which keep their real price.
// Odds (rate) and case prices are never touched.
CASES.forEach((c) => {
  const min = Math.min(...c.items.map((i) => i.value));
  c.items.forEach((i) => { if (i.value === min && !i.name.trim().startsWith("$")) i.value = 0.01; });
});

export const fmtUsd = (v) => `$${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtRate = (r) => `${r < 1 ? Number(r.toPrecision(2)) : r}%`;

// On-the-fly image optimizer: downsizes heavy PNG thumbnails and serves WebP
// so mobile isn't downloading multi-MB originals for tiny cards.
export const optimize = (url, w = 640) => {
  if (!url) return url;
  if (url.startsWith("/")) return url; // local asset (transparent PNG) — serve as-is
  const host = url.replace(/^https?:\/\//, "");
  return `https://images.weserv.nl/?url=ssl:${host}&w=${w}&output=webp&q=78`;
};

// Brand/category label shown under each case name in the detail panel.
export const BRAND_BY_ID = {
  "sheepskin": "UGG", "flight-club": "Jordan",
  "bullseye": "Target", "companion": "KAWS", "one-up": "Nintendo",
  "snapshot": "Polaroid", "basecamp": "The North Face", "airborne": "DJI", "cyclone": "Dyson",
  "black-bolt": "Pokémon", "sport-mode": "Crocs", "bulk-buy": "Costco", "quenched": "Stanley",
  "glow-up": "Sephora", "coffee-run": "Starbucks", "blue-tag": "Best Buy", "no-shade": "Ray-Ban",
  "second-hand": "Seiko", "jobsite": "DeWalt", "green-light": "Xbox", "monogram": "Louis Vuitton",
  "street-archive": "Supreme + Stüssy", "cupertino": "Apple", "m-division": "BMW",
  "player-one": "PlayStation", "golden-arches": "McDonald's", "crowned": "Rolex",
};

// Case thumbnails (user-provided product photos).
export const CASE_THUMBS = {
  "sheepskin": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/6h782qwc_A438B63C-55FA-48C7-847D-1C8951F66124_converted.webp",
  "flight-club": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/49lk87ff_B65C87C3-55BB-4511-92E7-C9EF1DCBAD23_converted.webp",
  "bullseye": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/igww1w1y_D283742F-1462-4894-BFE7-726BB8BB29F4.webp",
  "companion": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/yc4e7lzy_5130AE54-AC53-49B3-A22B-90A60F2B2EB4.webp",
  "one-up": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/3ep689hh_ABE8C84F-FA2E-46C2-8CFF-A78C42CEA0D4.webp",
  "snapshot": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/obpptvuf_6AEB39A0-CFDE-4B5C-A955-5C5773C0474D.webp",
  "basecamp": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/le2ackiw_08D65029-C397-4A83-826B-B42D803BC7F4.webp",
  "airborne": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/zp1wp27d_5DE51E60-008A-4668-A3D7-35A6257E6863.webp",
  "cyclone": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/56j4xx17_CEC5B118-9315-420F-81E7-F9CD29DE1C0E.webp",
  "black-bolt": "https://customer-assets-jai6qajn.emergentagent.net/job_solana-lucky-flip/artifacts/ssyef5ej_blackbolt.png",
  "sport-mode": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/136a7v9n_59643AC9-8637-4C57-A884-29DD37F9A356.webp",
  "bulk-buy": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/fgifruwj_B29D0F20-6F6D-4479-96D2-61546A306F84.webp",
  "quenched": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/guqwz1nd_537117A3-3B29-4794-8740-6708294F11BE.webp",
  "glow-up": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/dnmd9bxp_80337246-488F-42FF-8CFD-E8A84C03366C.webp",
  "coffee-run": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/x9vmicf3_31A5F6D7-C8D1-4309-B0C4-76C7C502CF31.webp",
  "blue-tag": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/87l1y1n9_CE5026C9-41EE-4A24-A372-26B4B81B261F.webp",
  "no-shade": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/fi5c5do3_509C9A0B-F74D-4A05-AC6B-B47CEC2C4B58.webp",
  "second-hand": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/dq1mpzvz_40698A5C-B079-41BD-AEC1-F9C292A711C3.webp",
  "jobsite": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/yjy64pse_EC3C8331-10B6-4322-B89F-A8D7A86A578B.webp",
  "green-light": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/cajorvpk_6045CD4B-9BCF-4E6F-AE62-9817D0EAEEA0.webp",
  "monogram": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/bzwti5vv_997FFBE2-ABD4-4E45-94ED-7C391F0508E6.webp",
  "street-archive": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/3d6rfkk0_E369A807-0DF2-4870-BB9E-2A01063E3B02.webp",
  "cupertino": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/s1p26x8g_21D0751F-416E-4F5C-ADEB-3E431F597C60.webp",
  "m-division": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/uss5jrg9_295E14EA-102F-49F5-97CB-49E4A02E9A76.webp",
  "player-one": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/mergty31_4917300B-0129-4F93-B265-A3EC692B016B.webp",
  "golden-arches": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/elrnrb4o_5F84C659-0B63-431D-9758-0D1B3FFA2F77.webp",
  "crowned": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/i9b82k5d_CBA93D18-589B-4A5C-9063-E163B0517405.webp",
};

// Map an item name to a generic product-category keyword, then a real photo URL.
const KW = [
  [/switch 2 \+ game|game bundle|instant camera bundle|creator bundle/i, "giftbox"],
  [/switch|nintendo/i, "nintendoswitch"], [/pro controller|controller/i, "gamecontroller"],
  [/playstation|ps5/i, "playstation"], [/macbook/i, "laptop"],
  [/first-party|game$/i, "videogame"], [/dyson|supersonic/i, "hairdryer"],
  [/airpods/i, "earbuds"], [/gift card|eshop|shop card|starbucks card|best buy gift|best buy credit|sephora gift/i, "giftcard"],
  [/rare kaws|companion figure|chum|kaws collectible|kaws figure/i, "designertoy"],
  [/kaws tee|tee/i, "tshirt"], [/art book|book/i, "artbook"], [/tote/i, "totebag"],
  [/keychain/i, "keychain"], [/sticker|postcard/i, "stickers"],
  [/gopro|hero|flagship camera/i, "actioncamera"], [/battery|enduro/i, "battery"],
  [/grip|handler|floating/i, "camerastick"], [/head strap|strap/i, "camerastrap"],
  [/mount/i, "cameramount"], [/polaroid|i-2|now\+|polaroid go/i, "instantcamera"],
  [/film/i, "camerafilm"], [/album/i, "photoalbum"], [/frame|clip/i, "pictureframe"],
  [/playground|small collectible|photo accessory/i, "toy"],
  [/summit series|nuptse|denali|shell|fleece|hoodie/i, "jacket"],
  [/beanie/i, "beanie"], [/sock/i, "socks"], [/patch/i, "patch"], [/backpack/i, "backpack"],
  [/avata|drone|fly more/i, "drone"], [/osmo|pocket/i, "actioncamera"],
  [/mic/i, "microphone"], [/propeller/i, "dronepart"], [/cable|adapter/i, "cable"],
  [/vacuum/i, "vacuum"], [/airwrap|airstrait|dyson|styling|supersonic/i, "hairdryer"],
  [/filter/i, "airfilter"], [/comb|brush/i, "hairbrush"], [/storage case/i, "case"],
  [/chase card|holo|booster|blister|etb|collection|pokemon|pokémon/i, "tradingcard"],
  [/collaboration crocs|collab pair|echo clog|classic clog|clog|crocs/i, "clogs"],
  [/jibbitz|charm/i, "shoecharm"],
  [/quencher|stanley|iceflow|cooler|reusable cup|tumbler/i, "tumbler"],
  [/straw|boot/i, "tumbleraccessory"], [/fragrance|perfume|cologne/i, "perfume"],
  [/beauty mini|sample/i, "makeup"], [/coffee|starbucks collectible/i, "coffee"],
  [/kirkland snack|snack|small item/i, "snacks"], [/kirkland drink|drink/i, "beverage"],
  [/wayfarer|ray-ban|sunglasses|meta/i, "sunglasses"], [/lanyard/i, "lanyard"],
  [/cleaning cloth|cloth/i, "microfiber"],
  [/watch tool|tool kit/i, "tools"], [/pouch/i, "pouch"],
  [/strap|bracelet/i, "watchstrap"], [/prospex|presage|seiko|quartz|watch/i, "wristwatch"],
  [/combo kit|drill|impact|dewalt|power tool/i, "powertool"],
  [/bit set|bit pack/i, "drillbits"], [/tape measure/i, "tapemeasure"],
  [/utility knife/i, "utilityknife"], [/xbox/i, "gameconsole"],
  [/handbag|keepall/i, "handbag"], [/wallet|card holder/i, "wallet"],
  [/notebook|catalog|city guide|book|paper/i, "notebook"],
  [/supreme|stussy|stüssy|box logo/i, "streetwear"], [/ipad/i, "tablet"], [/airtag/i, "airtag"],
  [/exhaust|spoiler|steering|floor mats|bmw/i, "carpart"],
  [/valve cap|badge/i, "caraccessory"], [/decal/i, "sticker"],
  [/dualsense|portal|playstation/i, "playstation"],
  [/arch card/i, "giftcard"], [/merch bundle/i, "merch"],
  [/happy meal|mcdonald|nuggets|burger/i, "fastfood"],
  [/submariner|oyster|datejust|rolex gmt|gmt\/datejust/i, "luxurywatch"],
];
// ── Real item images ──────────────────────────────────────────────
// Keyed by EXACT item name; shared across every case an item appears in.
// Add new uploads here — anything missing falls back to a placeholder.
const A = "https://customer-assets-jai6qajn.emergentagent.net/job_solana-lucky-flip/artifacts";
export const ITEM_IMAGES = {
  "UGG Classic Beanie": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/461dfqlf_Screenshot_2026-09-02_at_3.44.42_AM-removebg-preview.png",
  "UGG Scuffette Slippers": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/zfuggo8t_Screenshot_2026-09-02_at_3.46.21_AM-removebg-preview.png",
  "UGG Fluff Yeah Slides": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/cw058vs2_Screenshot_2026-09-02_at_3.46.59_AM-removebg-preview.png",
  "UGG Cozy Socks": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/fsrmyfaq_uggcozysock-removebg-preview.png",
  "UGG Tasman Slippers": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/xah5sbkd_Screenshot_2026-09-02_at_3.47.28_AM-removebg-preview.png",
  "UGG Sherpa Mini Tote": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/6wgohane_Screenshot_2026-09-02_at_3.47.48_AM-removebg-preview.png",
  "UGG Classic Mini Boots": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/srefy991_Screenshot_2026-09-02_at_3.48.31_AM-removebg-preview.png",
  "UGG Ultra Mini Platform Boots": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/2snqvnvi_Screenshot_2026-09-02_at_3.48.53_AM-removebg-preview.png",
  "UGG Sticker": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/vx03oe2w_UGG-logo.png",
  "Air Jordan 4 Retro Fire Red": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/m2xmx0en_Screenshot_2026-09-02_at_3.53.46_AM-removebg-preview.png",
  "Air Jordan 1 High Bred": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/manl4zf9_Screenshot_2026-09-02_at_3.54.10_AM-removebg-preview.png",
  "Air Jordan 11 Concord": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/rmkveidk_Screenshot_2026-09-02_at_3.54.46_AM-removebg-preview.png",
  "Air Jordan 3 White Cement": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/rnz058vf_Screenshot_2026-09-02_at_3.55.26_AM-removebg-preview.png",
  "Jordan Duffle Bag": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/tl25ojdk_Screenshot_2026-09-02_at_3.56.37_AM-removebg-preview.png",
  "Jordan Flight Hoodie": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/arpe3j7z_Screenshot_2026-09-02_at_3.57.31_AM-removebg-preview.png",
  "Jordan Backpack": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/9sty2ez1_Screenshot_2026-09-02_at_3.58.09_AM-removebg-preview.png",
  "Jordan Logo Tee": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/ktu26zgn_Screenshot_2026-09-02_at_3.58.58_AM-removebg-preview.png",
  "Jordan Sticker": "https://customer-assets-agu9un31.emergentagent.net/job_787385b9-97f5-4363-a9be-ddd4d25a0727/artifacts/4sn5ip3i_Jumpman_logo.svg.webp",
  "Nintendo Switch 2": `${A}/5z5cyu2p_target_nintendo_switch_2.png`,
  "Dyson Supersonic": `${A}/7uivq28g_target_dyson_supersonic.png`,
  "AirPods 4": `${A}/c2te5x4k_target_airpods_4.png`,
  "Bullseye Playground Item": `${A}/se4e65nz_target_bullseye_playground_item.png`,
  "$100 Target Gift Card": `${A}/77ibhx1w_target_gift_card_100%281%29.png`,
  "$50 Target Gift Card": `${A}/dfdfobfv_target_gift_card_50%281%29.png`,
  "$25 Target Gift Card": `${A}/vm1jogwg_target_gift_card_25%281%29.png`,
  "$10 Target Gift Card": `${A}/268o747i_target_gift_card_10%281%29.png`,
  "$5 Target Gift Card": `${A}/7yqkbril_targetgiftcard5.png`,
  "Rare KAWS Figure": "/items/kaws/rare-figure.png",
  "KAWS COMPANION Figure": `${A}/b7hb4nvo_KAWS_COMPANION_Figure-removebg-preview.png`,
  "KAWS CHUM Figure": `${A}/ri5u2tx3_KAWS_CHUM_Figure-removebg-preview.png`,
  "KAWS Collectible": `${A}/ukvoodiw_KAWS_Collectible-removebg-preview.png`,
  "KAWS Tee": `${A}/ttjxg42p_KAWS_Tee-removebg-preview.png`,
  "KAWS Art Book": `${A}/gigl9mj1_kawsbook.png`,
  "KAWS Tote": `${A}/peys6a45_kawsbag.png`,
  "KAWS Keychain": `${A}/1yn5pd7g_keychainredo.png`,
  "KAWS Sticker/Postcard Pack": `${A}/rsk5b15o_sticker.webp`,
  "Switch 2 Pro Controller": `${A}/7s9giw4u_switch2controller.png`,
  "$50 Nintendo eShop Card": `${A}/44ucrtli_switch50%24gc.png`,
  "$25 eShop Card": `${A}/070kqc9n_switch25gc.png`,
  "$10 eShop Card": `${A}/9liubta4_swtich10gc.png`,
  "$5 eShop Card": `${A}/pqls3njz_switch5gc.png`,
  "Switch 2 + Game Bundle": `${A}/m7ab8emb_switchbundle-removebg-preview.png`,
  "First-Party Switch 2 Game": `${A}/4o7sa0me_switchgame.jpg`,
  "Nintendo Small Collectible": `${A}/avjyutcu_collectible-removebg-preview.png`,
  "DJI Mic Mini": `${A}/2u1xznf2_micmini-removebg-preview.png`,
  "DJI Avata/Premium Drone Bundle": `${A}/oq9svrr8_DJI_Avata_Premium_Drone_Bundle_-removebg-preview.png`,
  "DJI Mini Fly More Bundle": `${A}/1wwpzoch_dji_mini-removebg-preview.png`,
  "Osmo Pocket Creator Bundle": `${A}/arvhowey_osmopocketcreator-removebg-preview.png`,
  "Osmo Pocket 3": `${A}/nsexq578_pocket3-removebg-preview.png`,
  "Cable/Adapter": `${A}/pq0ho97m_osmocable-removebg-preview.png`,
  "Black Bolt Zekrom PSA 9.5": `${A}/cf668vs4_240-removebg-preview.png`,
  "Premium Black Bolt Collection": `${A}/bkl9kfg4_premiumblackbolt-removebg-preview.png`,
  "Pokémon Center Black Bolt ETB": `${A}/hd26aejq_blackboltpokemoncenteretb-removebg-preview.png`,
  "Black Bolt ETB": `${A}/w233wss4_blackboltetb-removebg-preview.png`,
  "Black Bolt 3-Pack Blister": `${A}/aj73mlnv_3packblister-removebg-preview.png`,
  "Black Bolt Holo/Reverse-Holo": `${A}/xy37mv0r_blackboltholo.jpeg`,
  "Black Bolt Booster Bundle": `${A}/3ik9wvpb_blackboltboosterbundle-removebg-preview.png`,
  "Black Bolt Booster Pack": `${A}/sedpilrj_blackboltboosterpack.jpg`,
  "Battery/Charging Hub": `${A}/d52rrp2y_charginghub-removebg-preview.png`,
  "Propeller/Accessory Kit": `${A}/ydu3xtv5_propeller-removebg-preview.png`,
  "Small DJI Accessory": `${A}/vvpox7ek_accessory-removebg-preview.png`,
  "DJI Sticker/Tiny Accessory": `${A}/xa5zbx1h_dji_sticker-removebg-preview.png`,
  "Costco Hot Dog": `${A}/bwb0quzo_costcohotdog.png`,
  "Costco Pizza Slice": `${A}/s3wy2cqd_costco_pizza-removebg-preview.png`,
  "$100 Costco Shop Card": `${A}/he0874hd_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_34_09%20PM%20%285%29.png`,
  "$50 Shop Card": `${A}/xso77o2q_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_34_09%20PM%20%284%29.png`,
  "$25 Shop Card": `${A}/b4zmmhus_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_34_08%20PM%20%283%29.png`,
  "$10 Shop Card": `${A}/1bdvabz0_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_34_08%20PM%20%282%29.png`,
  "$5 Shop Card": `${A}/r5z02wwo_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_34_07%20PM%20%281%29.png`,
  "Rare Starbucks x Stanley": `${A}/27yynr4q_rarestanley.png-removebg-preview.png`,
  "Limited Starbucks Tumbler": `${A}/7b4pwmwr_collectible%20cup.png`,
  "Reusable Cup": `${A}/n1psrx6t_resuablecup-removebg-preview.png`,
  "Starbucks Cake Pop": `${A}/akmx8gmx_cakepop-removebg-preview.png`,
  "$100 Starbucks Card": `${A}/9fr6deo9_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_48_31%20PM%20%281%29.png`,
  "$25 Starbucks Card": `${A}/sxv9s7tx_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_48_31%20PM%20%282%29.png`,
  "$15 Starbucks Card": `${A}/m21oqqlt_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_48_32%20PM%20%283%29.png`,
  "$10 Starbucks Card": `${A}/6zlckcff_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_48_32%20PM%20%284%29.png`,
  "$5 Starbucks Card": `${A}/91c5gope_ChatGPT%20Image%20Aug%2028%2C%202026%20at%2012_48_33%20PM%20%285%29.png`,
  "Ray-Ban Meta": `${A}/s81jhhxw_raybanmeta-removebg-preview.png`,
  "Original Wayfarer Polarized": `${A}/c4r7vobl_image-removebg-preview-2.png`,
  "Original Wayfarer": `${A}/ai5mdqt5_image-removebg-preview.png`,
  "Premium Ray-Ban Sunglasses": `${A}/zad68gzk_image-removebg-preview-3.png`,
  "Ray-Ban Lanyard": `${A}/thsfkk4d_Screenshot_2026-08-28_at_12.58.14_PM-removebg-preview.png`,
  "Cleaning Cloth": `${A}/bc024gga_Screenshot_2026-08-28_at_12.58.54_PM-removebg-preview.png`,
  "Case Accessory": `${A}/tlxigvf4_Screenshot_2026-08-28_at_12.59.50_PM-removebg-preview.png`,
  "Small Ray-Ban Accessory": `${A}/uiburt9a_Screenshot_2026-08-28_at_1.01.44_PM-removebg-preview.png`,
  "Ray-Ban Care Kit": `${A}/y3bx8bvc_raybancarekit-removebg-preview.png`,
  "Xbox Series X": `${A}/baw77rtj_image-removebg-preview-6.png`,
  "Xbox Series S": `${A}/7tj2vhja_xboxs.png`,
  "Elite Wireless Controller": `${A}/712n5fsv_image-removebg-preview-5.png`,
  "Xbox Wireless Controller": `${A}/0fjt1hoq_image-removebg-preview-4.png`,
  "$50 Xbox Card": `${A}/80iajms9_xbox50.png`,
  "$25 Xbox Card": `${A}/mbah5sde_xbox25.png`,
  "$10 Xbox Card": `${A}/59joz66p_xbxo10.png`,
  "$5 Xbox Card": `${A}/entqel1m_xbox5.png`,
  "$2 Xbox Digital Credit": `${A}/y2cs7w4d_xbxo2.png`,
  "MacBook Air": `${A}/t0o7yhwv_Screenshot_2026-08-28_at_3.09.29_PM-removebg-preview.png`,
  "iPad": `${A}/csbhtwle_Screenshot_2026-08-28_at_3.10.01_PM-removebg-preview.png`,
  "Apple Watch SE": `${A}/izzbg1ud_fs-removebg-preview.png`,
  "AirPods 4 ANC": `${A}/nzv1z8ke_airpods-removebg-preview.png`,
  "$2 Apple Credit": `${A}/gm36bmya_apple_gift_card_2-removebg-preview.png`,
  "$10 Apple Gift Card": `${A}/fbsblzeh_apple_gift_card_10-removebg-preview.png`,
  "$5 Apple Gift Card": `${A}/sg8l7e8u_apple_gift_card_5-removebg-preview.png`,
  "AirTag": `${A}/zkkk0ymb_airtag-4pack-select-202601_FMT_WHH.png`,
  "$250 Arch Card": `${A}/qsssej6o_mcdonadls250.png`,
  "$100 Arch Card": `${A}/zmpuakox_mcdonalds100.png`,
  "$50 Arch Card": `${A}/3fipdp4l_mcodnadls50.png`,
  "Grimace Toy": `${A}/pi24dxo6_Screenshot_2026-08-28_at_3.26.34_PM-removebg-preview.png`,
  "Potato Head Toy": `${A}/iqj483hu_Screenshot_2026-08-28_at_3.26.52_PM-removebg-preview.png`,
  "$75 Arch Card": `${A}/liog5lou_mcdonadls75.png`,
  "$5 Meal Deal": `${A}/5pni283a_Screenshot_2026-08-28_at_3.32.33_PM-removebg-preview.png`,
  "Mac Meal": `${A}/6jkfaovf_Screenshot_2026-08-28_at_3.34.49_PM-removebg-preview.png`,
  "$25 Arch Card": `${A}/61x7yd2e_25%24.png`,
  "Rolex Submariner": `${A}/cycrmx4b_Screenshot_2026-08-28_at_3.40.12_PM-removebg-preview.png`,
  "Rolex GMT-Master II": `${A}/vc0i2yqz_Screenshot_2026-08-28_at_3.40.50_PM-removebg-preview.png`,
  "Rolex Oyster Perpetual": `${A}/m6e6phig_image-removebg-preview-7.png`,
  "Rolex Box + Papers Set": `${A}/ghg6rovd_Rolex-Box-Papers-and-Warranty-Card-removebg-preview.png`,
  "Rolex Service Pouch": `${A}/l1oht2xo_Screenshot_2026-08-28_at_3.43.46_PM-removebg-preview.png`,
  "Rolex Collector Book": `${A}/ae982vnu_Screenshot_2026-08-28_at_3.44.42_PM-removebg-preview.png`,
  "Rolex Travel/Display Accessory": `${A}/7ifgaec7_Screenshot_2026-08-28_at_3.45.55_PM-removebg-preview.png`,
  "Rolex Catalog/Magazine": `${A}/j633e46d_Screenshot_2026-08-28_at_3.46.34_PM-removebg-preview.png`,
  "Rolex Tag/Paper Collectible": `${A}/028n8ckp_Screenshot_2026-08-28_at_3.47.52_PM-removebg-preview.png`,
  "Small Rolex Paper Collectible": `${A}/852y9iy1_Screenshot_2026-08-28_at_3.47.14_PM-removebg-preview.png`,
  "USB-C Cable": `${A}/buukwj1l_usbc-removebg-preview.png`,
  "Polaroid Go": `${A}/ya05body_Go_Blue__Shadows_V1.png.webp`,
  "Polaroid I-2": `${A}/vsuhzj7m_I2_Shadows_V2.png.webp`,
  "Double Film Pack": `${A}/80bpad9i_006211_2_Pack_Version.png.webp`,
  "Premium Instant Camera Bundle": `${A}/vhk4y2jd_88357a55-f42c-4c69-b933-8208a3513b22.jpg_maxHeight_1920_maxWidth_900-removebg-preview.png`,
  "Polaroid Now+": `${A}/0f4uspps_Screenshot_2026-08-29_at_3.53.41_PM-removebg-preview.png`,
  "Photo Album": `${A}/wecoydou_Screenshot_2026-08-29_at_3.57.29_PM-removebg-preview.png`,
  "Frame/Clip Set": `${A}/e7erqpxp_Screenshot_2026-08-29_at_3.59.55_PM-removebg-preview.png`,
  "Photo Frame": `${A}/e7erqpxp_Screenshot_2026-08-29_at_3.59.55_PM-removebg-preview.png`,
  "Small Photo Accessory": `${A}/g1qbxs8h_stack-of-old-blank-photographs-thumb30.png`,
  "Old Photos": `${A}/g1qbxs8h_stack-of-old-blank-photographs-thumb30.png`,
  "Color Film": `${A}/2tzyqokg_Screenshot_2026-08-29_at_3.56.38_PM-removebg-preview.png`,
  "Premium Dyson Cordless Vacuum": `${A}/yhv0x076_image-removebg-preview-14.png`,
  "Dyson Airwrap": `${A}/el3sv3wx_image-removebg-preview-13.png`,
  "Dyson Airstrait": `${A}/yzj30t7h_image-removebg-preview-12.png`,
  "Premium Styling Attachment": `${A}/xslxuvw4_s2827830-main-zoom.jpg-removebg-preview.png`,
  "Replacement Filter": `${A}/2tax84sz_image-removebg-preview-11.png`,
  "Small Attachment": `${A}/lnaztg1r_image-removebg-preview-8.png`,
  "Comb/Brush Accessory": `${A}/72s1read_image-removebg-preview-9.png`,
  "Storage Case": `${A}/gfk8l2sj_image-removebg-preview-10.png`,
  "Dyson Sticker": `${A}/xrbtaa5t_images-removebg-preview.png`,
  "Rare Stanley Collaboration": `${A}/443uculg_barbiestanley.webp`,
  "Limited Quencher": `${A}/ib1y5b08_quencher.webp`,
  "Quencher 40oz": `${A}/tsabvexb_quencher40z.webp`,
  "Quencher 30oz": `${A}/p97m8ute_Web_PNG_Square-_The_Quencher_H2.0_Flowstate_Tumbler_30OZ_-_Blue_Dream_Stone_-_Front.png.webp`,
  "Stanley Cooler": `${A}/dyig3mcg_stanleycooler.webp`,
  "IceFlow Bottle": `${A}/5f9mi42j_Web_PNG_Square-The_IceFlow_Flip_Straw_2.0_Tumbler-30_oz_0.89_L-Champagne-Front_5dab91cd-d613-439a-9bf8-ff37f9c98fb2.png.webp`,
  "Straw Topper Set": `${A}/af4js0d8_strawtopper.webp`,
  "Topper": `${A}/hdtpx9la_boot_charm-removebg-preview.png`,
  "Stanley Sticker": `${A}/q9sarn0u_image-removebg-preview-15.png`,
  "PlayStation 5 Pro": `${A}/gh5bw9kb_image-removebg-preview-16.png`,
  "SanDisk 256GB Extreme Pro": `${A}/uztud4ql_sandisk.webp`,
  "Logitech G432 Wired Headset": `${A}/jfyom4bw_logitech_g432-removebg-preview.png`,
  "Rayovac 4 Pack Batteries": `${A}/nchwxalr_rayovac.webp`,
  "Best Buy Sticker": `${A}/susg8zqx_bestbuy.webp`,
  "Soundcore by Anker": `${A}/67k1mw31_soundcore-removebg-preview.png`,
  "Anker 20W Wall Charger": `${A}/nrzmrz5i_Screenshot_2026-08-29_at_4.55.10_PM-removebg-preview.png`,
  "Tape Measure": `${A}/9r0u2fz6_Screenshot_2026-08-29_at_5.50.24_PM-removebg-preview.png`,
  "Bit Set": `${A}/9h3kkf1k_Screenshot_2026-08-29_at_5.50.44_PM-removebg-preview.png`,
  "Battery 2-Pack": `${A}/zcxpp29h_Screenshot_2026-08-29_at_5.50.56_PM-removebg-preview.png`,
  "Utility Knife": `${A}/0jy6cnwu_Screenshot_2026-08-29_at_5.51.46_PM-removebg-preview.png`,
  "Supreme Shanghai Box Logo Hoodie": `${A}/hh70co23_Screenshot_2026-08-29_at_6.01.52_PM-removebg-preview.png`,
  "Supreme Jacket": `${A}/gu12kvzq_Screenshot_2026-08-29_at_6.04.39_PM-removebg-preview.png`,
  "Stüssy Premium Jacket": `${A}/kbm4b2ui_Screenshot_2026-08-29_at_6.06.07_PM-removebg-preview.png`,
  "Supreme Hoodie": `${A}/z2d2h070_Screenshot_2026-08-29_at_6.07.19_PM-removebg-preview.png`,
  "Stüssy Hoodie": `${A}/b9xjb526_Screenshot_2026-08-29_at_6.08.36_PM-removebg-preview.png`,
  "Supreme Tee": `${A}/vtnydapn_Screenshot_2026-08-29_at_6.09.09_PM-removebg-preview.png`,
  "Stüssy Tee": `${A}/14rsr5u0_Screenshot_2026-08-29_at_6.20.33_PM-removebg-preview.png`,
  "Socks": `${A}/hfo2uuja_Screenshot_2026-08-29_at_6.12.22_PM-removebg-preview.png`,
  "Burberry X Supreme Sticker": `${A}/bhlyzz6w_Screenshot_2026-08-29_at_6.20.04_PM-removebg-preview.png`,
  "Supreme Sticker": `${A}/w90v2pyz_Screenshot_2026-08-29_at_6.23.01_PM-removebg-preview.png`,
  "PlayStation 5": `${A}/2nyaephn_Screenshot_2026-08-29_at_6.33.51_PM-removebg-preview.png`,
  "PlayStation Portal": `${A}/fgf48nu1_Screenshot_2026-08-29_at_6.34.14_PM-removebg-preview.png`,
  "DualSense Edge": `${A}/ksty0gjl_Screenshot_2026-08-29_at_6.34.38_PM-removebg-preview.png`,
  "DualSense Controller": `${A}/8hnv0emv_Screenshot_2026-08-29_at_6.35.01_PM-removebg-preview.png`,
  "Hello Kitty Island Adventure": `${A}/gphx96bt_Screenshot_2026-08-29_at_6.35.46_PM-removebg-preview.png`,
  "PS5 Charging Station": `${A}/tacfupew_Screenshot_2026-08-29_at_6.38.20_PM-removebg-preview.png`,
  "PS5 Charger": `${A}/5be6ht7p_Screenshot_2026-08-29_at_6.38.51_PM-removebg-preview.png`,
  "Control Freaks": `${A}/yeckt9ra_Screenshot_2026-08-29_at_6.39.40_PM-removebg-preview.png`,
  "PS5 Sticker": `${A}/trl9j90t_image-removebg-preview-17.png`,
  "Summit Series Shell": `${A}/ejxml3om_north_face-ms-summit-l4-wndstpr-hoodie-ylw-blk-removebg-preview.png`,
  "1996 Retro Nuptse": `${A}/5xs5iy55_product-215266-1758812616-NF0A3XEO-removebg-preview.png`,
  "Denali Fleece": `${A}/ofebq41p_image-removebg-preview-18.png`,
  "Borealis Backpack": `${A}/43d2gzc0_Screenshot_2026-08-29_at_6.52.37_PM-removebg-preview.png`,
  "TNF Hoodie": `${A}/7q3zbw46_image-removebg-preview-19.png`,
  "TNF Tee": `${A}/j8go8462_image-removebg-preview-20.png`,
  "TNF Beanie": `${A}/dzg4jzo9_image-removebg-preview-21.png`,
  "TNF Socks": `${A}/4ih85gbe_image-removebg-preview-22.png`,
  "TNF Sticker": `${A}/krv7oeae_image-removebg-preview-23.png`,
  "Pollex clog": `${A}/hii2w52a_Screenshot_2026-08-29_at_7.22.18_PM-removebg-preview.png`,
  "Premium Collab Pair": `${A}/kp9kqmq1_Screenshot_2026-08-29_at_7.23.19_PM-removebg-preview.png`,
  "Echo Clog": `${A}/0p1j25mx_Screenshot_2026-08-29_at_7.23.53_PM-removebg-preview.png`,
  "Classic Clog": `${A}/hcnbg9iu_Screenshot_2026-08-29_at_7.24.20_PM-removebg-preview.png`,
  "Hello Kitty 5 Pack Jibbitz": `${A}/sz736nge_Screenshot_2026-08-29_at_7.26.06_PM-removebg-preview.png`,
  "Jibbitz 5-Pack": `${A}/n2v6sqyt_Screenshot_2026-08-29_at_10.12.30_PM-removebg-preview.png`,
  "Jibbitz 3-Pack": `${A}/2qpusu1w_Screenshot_2026-08-29_at_10.15.46_PM-removebg-preview.png`,
  "Premium Single Jibbitz": `${A}/mr9w6a6f_image-removebg-preview-25.png`,
  "Small Crocs Charm": `${A}/uun6ksgp_image-removebg-preview-24.png`,
  "Crystal Contour Collection": `${A}/ph3k9vxl_CRYSTAL_COUNTOUR-removebg-preview.png`,
  "YSL Make Me Blush": `${A}/k7d5hvks_ysl-removebg-preview.png`,
  "Rhode Pocket Bronze Long": `${A}/aa6ud8h4_s2981116-main-zoom-removebg-preview.png`,
  "Colorful 8HR Longwear Transferproof Lip Liner": `${A}/b6tfaolc_lipliner-removebg-preview.png`,
  "Nourishing Foot Mask in Coconut": `${A}/hnmk74wh_footmask-removebg-preview.png`,
  "Seiko Prospex": `${A}/oxz4mv3g_Screenshot_2026-08-29_at_10.39.29_PM-removebg-preview.png`,
  "Seiko Presage": `${A}/mkj5arn4_Screenshot_2026-08-29_at_10.40.14_PM-removebg-preview.png`,
  "Seiko 5 Sports": `${A}/ogm2i6px_Screenshot_2026-08-29_at_10.40.53_PM-removebg-preview.png`,
  "Seiko Quartz Watch": `${A}/4ckrbs05_Screenshot_2026-08-29_at_10.42.31_PM-removebg-preview.png`,
  "Leather Strap": `${A}/7pop4dfo_Screenshot_2026-08-29_at_10.43.00_PM-removebg-preview.png`,
  "Bracelet/Strap": `${A}/ke100q3z_bracelt-removebg-preview.png`,
  "Watch Tool Kit": `${A}/9f0lxxyi_Screenshot_2026-08-29_at_10.44.59_PM-removebg-preview.png`,
  "Watch Pouch": `${A}/wllrtxww_Screenshot_2026-08-29_at_10.45.34_PM-removebg-preview.png`,
  "Cloth/Spring-Bar Tool": `${A}/p214yjc2_Screenshot_2026-08-29_at_10.46.02_PM-removebg-preview.png`,
  "LV Neverfull": `${A}/2qi60m22_louis-vuitton-neverfull-gm--M46978_PM2_Front%20view.jpg.webp`,
  "BMW Badge": `${A}/uc0dpzx9_Screenshot_2026-08-29_at_11.27.37_PM-removebg-preview.png`,
  "BMW M Cap": `${A}/m8hdbz9z_Screenshot_2026-08-29_at_11.26.35_PM-removebg-preview.png`,
  "BMW Keychain": `${A}/b3op9qy4_Screenshot_2026-08-29_at_11.27.02_PM-removebg-preview.png`,
  "Sticker": `${A}/bo2t7p51_bmw-removebg-preview.png`,
  "BMW M Decal": `${A}/y5ddpblr_bmw-m-outline-removebg-preview.png`,
  "M Performance Exhaust/Major Part": `${A}/9ctbf15q_Screenshot_2026-08-29_at_11.19.17_PM-removebg-preview.png`,
  "Carbon Spoiler": `${A}/p5h0far6_carbon_spoiler-removebg-preview.png`,
  "M Steering Wheel/Trim": `${A}/l6b5uhaj_image-removebg-preview-27.png`,
  "Genuine BMW Floor Mats": `${A}/nq66k5eo_Screenshot_2026-08-29_at_11.24.11_PM-removebg-preview.png`,
  "BMW M Thermo Mug Black": `${A}/0al8ynbo_Screenshot_2026-08-29_at_11.24.49_PM-removebg-preview.png`,
  "LV Keepall": `${A}/qwpj5qvr_Screenshot_2026-08-29_at_11.14.35_PM-removebg-preview.png`,
  "LV Paper Bag": `${A}/iuo63x80_Screenshot_2026-08-29_at_10.59.56_PM-removebg-preview.png`,
  "LV Receipt Holder": `${A}/15lag4zx_Screenshot_2026-08-29_at_11.00.19_PM-removebg-preview.png`,
  "LV Card Holder": `${A}/w38zszwe_Screenshot_2026-08-29_at_10.55.05_PM-removebg-preview.png`,
  "LV Sarah Wallet": `${A}/5s4tb7fn_Screenshot_2026-08-29_at_10.55.40_PM-removebg-preview.png`,
  "LV Key Pouch": `${A}/uuyaehqv_Screenshot_2026-08-29_at_10.56.10_PM-removebg-preview.png`,
  "LV City Guide/Book": `${A}/5u3dn036_Screenshot_2026-08-29_at_10.56.44_PM-removebg-preview.png`,
  "LV Notebook": `${A}/jb6i13ka_Screenshot_2026-08-29_at_10.57.05_PM-removebg-preview.png`,
  "Baccarat Rouge 540": `${A}/xbg2uiwv_baccarat-removebg-preview.png`,
  "$150 Sephora Gift Card": `${A}/5904n4sl_image-removebg-preview-26.png`,
  "Sandalwood Mini Perfume Sample 0.05 oz": `${A}/969z6tty_Screenshot_2026-08-29_at_10.31.49_PM-removebg-preview.png`,
  "20V MAX Battery": `${A}/up6n1dut_dewaltbattery-removebg-preview.png`,
  "6-Tool Combo Kit": `${A}/cp7pwvy8_Screenshot_2026-08-29_at_5.53.01_PM-removebg-preview.png`,
  "4-Tool Combo Kit": `${A}/qa9jgjeo_Screenshot_2026-08-29_at_5.53.16_PM-removebg-preview.png`,
  "Drill/Impact Kit": `${A}/xc2n3vfa_Screenshot_2026-08-29_at_5.54.11_PM-removebg-preview.png`,
  "Small DeWalt Accessory": `${A}/k3y086qw_Screenshot_2026-08-29_at_5.54.47_PM-removebg-preview.png`,
};

// Shared registry of image URLs that have finished loading at least once, so
// components (e.g. the spin reel) can render them as ready with no re-swirl.
export const LOADED = new Set();
export const markLoaded = (u) => { if (u) LOADED.add(u); };
export const isLoaded = (u) => LOADED.has(u);

export function imgFor(name) {
  // Prefer a real uploaded image. Local (/…) served as-is; remote optimized.
  if (ITEM_IMAGES[name]) { const u = ITEM_IMAGES[name]; return u.startsWith("/") ? u : optimize(u, 320); }
  // Fallback placeholder keyed by product category.
  let kw = "product";
  for (const [re, k] of KW) { if (re.test(name)) { kw = k; break; } }
  let h = 0; for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 97;
  return `https://loremflickr.com/240/240/${kw}?lock=${h + 1}`;
}

// Each item already carries its exact drop rate.
export function itemsWithRates(caseObj) {
  return caseObj.items;
}

// Weighted pick using each item's exact percentage.
export function pickItem(caseObj) {
  const items = caseObj.items;
  const total = items.reduce((s, i) => s + i.rate, 0);
  let r = Math.random() * total;
  for (const i of items) { r -= i.rate; if (r <= 0) return i; }
  return items[items.length - 1];
}
